export const ProductNames = {
  CREDIT: 'credit',
  DEBT_CONSOLIDATION: 'debtConsolidation',
  LOAN: 'loan',
} as const;

export type ProductName = (typeof ProductNames)[keyof typeof ProductNames];
